module.exports = __webpack_public_path__ + "img/26.34b231b3.svg";